import React, { useEffect, useState, createContext, useContext } from 'react';
import type { LeadScoreResult } from '../utils/leadScore';
export type Page = 'landing' | 'quiz' | 'email' | 'loading' | 'results' | 'offer' | 'checkout' | 'thanks';
interface AppState {
  currentPage: Page;
  setCurrentPage: (page: Page) => void;
  answers: Record<number, string | string[]>;
  setAnswer: (questionIndex: number, answer: string | string[]) => void;
  userName: string;
  setUserName: (name: string) => void;
  userEmail: string;
  setUserEmail: (email: string) => void;
  orderBump: boolean;
  setOrderBump: (bump: boolean) => void;
  timeLeft: string;
  leadScore: LeadScoreResult | null;
  setLeadScore: (score: LeadScoreResult | null) => void;
}
const AppContext = createContext<AppState | undefined>(undefined);
export const AppProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [currentPage, setCurrentPage] = useState<Page>('landing');
  const [answers, setAnswers] = useState<Record<number, string | string[]>>({});
  const [userName, setUserName] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [orderBump, setOrderBump] = useState(false);
  const [timeLeft, setTimeLeft] = useState('23:59:59');
  const [leadScore, setLeadScore] = useState<LeadScoreResult | null>(null);
  const setAnswer = (questionIndex: number, answer: string | string[]) => {
    setAnswers(prev => ({
      ...prev,
      [questionIndex]: answer
    }));
  };
  useEffect(() => {
    // Initialize a 24h countdown
    const endTime = new Date().getTime() + 24 * 60 * 60 * 1000;
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = endTime - now;
      if (distance < 0) {
        clearInterval(timer);
        setTimeLeft('00:00:00');
        return;
      }
      const hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(distance % (1000 * 60) / 1000);
      setTimeLeft(`${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <AppContext.Provider value={{
    currentPage,
    setCurrentPage,
    answers,
    setAnswer,
    userName,
    setUserName,
    userEmail,
    setUserEmail,
    orderBump,
    setOrderBump,
    timeLeft,
    leadScore,
    setLeadScore
  }} data-id="element-17">
      {children}
    </AppContext.Provider>;
};
export const useAppContext = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};